module.exports = __webpack_public_path__ + "img/energy-pathway.43d98677.jpg";